
//import { ModalService, ControlsComponent, SelectizeComponent, AppCodes, StepperComponent, ToastService } from '../../blocks';
//import { AppCodeGroup, ControlsParams, UserSessionService, StockParms, SharedDateService, CashierParms, UIAction } from '../../shared';
import { getDateObj, getNgBsObj, UserSessionService, SharedDateService } from '../../shared';
import { UntypedFormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Injectable } from '@angular/core';
import { SelectizeComponent, ToastService } from '../../blocks';
import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { GenerateQrCodeService, QrCodeParams } from './generate-qr-code.service';

@Injectable()
export class StockHelper {
  sumOfItemCost: number;
  sumOfItemSall: number;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private _toastService: ToastService,
    private _userSessionService: UserSessionService,
    private _generateQrCodeService: GenerateQrCodeService,
    private _dateService: SharedDateService, private datePipe: DatePipe

  ) {
  }
  OnStoreSelect(store: any, itemMainDataSelectize: SelectizeComponent, form: UntypedFormGroup, SearchProp: string) {

    if (store) {
      if (this.checkStoreUnderInventory(store)) {
        if (form)
          this.whenStoreUnderInventory(form);
        this.resetSelectize(itemMainDataSelectize)
      }
      itemMainDataSelectize.setFastSearchKey(SearchProp, store.code);
    }
  }
  OnStoreChechIfUnderInventory(store, form: UntypedFormGroup, itemMainDataSelectize: SelectizeComponent) {
    if (this.checkStoreUnderInventory(store)) {
      this.whenStoreUnderInventory(form);
      this.resetSelectize(itemMainDataSelectize)
    }
  }
  resetSelectize(sl: SelectizeComponent) {
    if (sl) {
      sl.clear();
      sl.clearItems();
    }

  }
  checkStoreUnderInventory(store: any) {
    return store.underInventory || 0;
  }
  whenStoreUnderInventory(form: UntypedFormGroup) {
    this.showUiMessage('UNDERINVENTORY');
    this.resetMasterFormStorAndTransDate(form);
  }
  resetMasterForm() {

  }
  resetMasterFormStorAndTransDate(form: UntypedFormGroup) {
    form.get("storeCode").setValue('');
    let date = getNgBsObj(new Date());
    form.get("transDate").setValue(date);
  }
  showUiMessage(messageCode) {
    this._toastService.activateMsg('UNDERINVENTORY');
  }
  //--------------------------------------------------------------


  chekIfDurgsOrConsumbales(store1ByUser: SelectizeComponent, itemMainDataSelectize: SelectizeComponent, SearchPrp: string) {
    this._userSessionService.subscribeToKey$('RouterParms').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value && store1ByUser) {

          this.resetSelectize(store1ByUser)
          store1ByUser.setFastSearchObjDynamicKey(SearchPrp, keys.value);

        }
        if (keys.value && itemMainDataSelectize) {

          this.resetSelectize(itemMainDataSelectize)
          itemMainDataSelectize.setFastSearchObjDynamicKey(SearchPrp, keys.value);
        }
      });

  }
  setSearchASConsumbales(sl: SelectizeComponent) { }
  setSearchASDrugs(sl: SelectizeComponent) {

  }
  checkExchangeServiceConsumbales() { }
  checkExchangeServiceConsussmbales() { }




  _addItem(item: any, items: any[], amount: number) {

    for (var i = 0; i < item.length; i++) {

      if (items.find(x => x.code == item[i]["code"])) {
        return false;
      }
      else {

        if (amount) {
          for (var x = 0; x < amount; x++) {
            let itemCopy = Object.assign({}, item[i])
            itemCopy.number = 1;
            items.push(itemCopy);
          }
        }

        else { items.push(item[i]); }
      }
    }
    return items;
  }


  _numberChange(row, form: UntypedFormGroup, items, roundFinancialFigures?: number) {

    if (items.length == 0) {
      form.get('totalSale').setValue(0);
      form.get('totalCost').setValue(0);
    }
    if (row['number'] == 0) {
      this._toastService.activateMsg('UI91');
      return false;
    }
    if (row['number'] != (undefined || null) && row['number'] != "") {

      row['netOfPiceUnits'] = row['unitCost'] * row['number'];
      if (roundFinancialFigures) row['netOfPiceUnits'] = +row['netOfPiceUnits'].toFixed(roundFinancialFigures);
      row['netOfPiceitem'] = row['unitSale'] * row['number'];
      if (roundFinancialFigures) row['netOfPiceitem'] = +row['netOfPiceitem'].toFixed(roundFinancialFigures);

    }
    return row
  }


  calSumItemCostAndSAle(items, form: UntypedFormGroup, roundFinancialFigures?: number) {
    var sum = 0;
    var sum1 = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].number != undefined || items[i].number != null) {
        //----------------------------------------------------------عشان اجيب تكلفه كل العناصر اللى ف الجدول
        sum += +items[i].netOfPiceUnits;
        var sumOfItemCost = sum;
        sum1 += +items[i].netOfPiceitem;
        var sumOfItemSall = sum1
        //----------------------------------------------------------عشان اجيب تكلفه كل العناصر اللى ف الجدول
        if (sumOfItemCost != undefined || sumOfItemCost != null) {
          this.sumOfItemCost = +sumOfItemCost
          this.sumOfItemCost = +this.sumOfItemCost.toFixed(roundFinancialFigures)
          form.get('totalCost').setValue(this.sumOfItemCost);
        }
        if (sumOfItemSall != undefined || sumOfItemSall != null) {
          this.sumOfItemSall = +sumOfItemSall
          this.sumOfItemSall = +this.sumOfItemSall.toFixed(roundFinancialFigures)
          form.get('totalSale').setValue(this.sumOfItemSall);
        }
      }

    }

  }


  resetForm(form: UntypedFormGroup) {
    if (form) {
      let date = this._dateService.convertFromDateToNgBsObject(new Date());
      form.reset();
      form.get('transDate').setValue(date);
    }

  }
  getSmallUnitValue(units: Array<any>, itemCode): Array<any> {
    return units.filter(item => item.factor == 1 && item.itemId == itemCode);
  }
  getUnitValue(units: Array<any>, unitCode: number, itemCode: any): Array<any> {
    return units.filter(item => item.serial == unitCode && item.itemId == itemCode);
  }

  getUnitValueByItems(units: Array<any>, itemCode: any): Array<any> {
    return units.filter(item => item.itemId == itemCode);
  }
  getUnitLargeValueByFactore(units: Array<any>, factor: number): Array<any> {
    return units.filter(item => item.factor == factor);
  }

  resetUIsession() {
    this._userSessionService.setSessionKey('TRANSSERIAL', {});
    this._userSessionService.setSessionKey('patientBanner', {});
    this._userSessionService.setSessionKey('patient', {});
    this._userSessionService.setSessionKey('contract', {});
    this._userSessionService.setSessionKey('Services', {});
    this._userSessionService.setSessionKey('visitData', {});
    this._userSessionService.setSessionKey('episodeData', {});
    this._userSessionService.setSessionKey('contractObjectForm', {});
  }

  getSpecificItemInArray(Items: Array<any>, itemCode): Array<any> {
    return Items.filter(item => item.code == itemCode);
  }
  getSpecificItemInArrayqQrCode(Items: Array<any>, itemCode): Array<any> {
    return Items.filter(item => item.code == itemCode && item.qrCode);
  }
  expirationDateValidationCheck(row) {
    if (row) {
      let date = new Date();
      let _vDate = this._dateService.convertFromNgBsToDate(row.expirationDate)
      if (_vDate < date) {
        this._toastService.activateMsg("UI1212", row.customCode);
      }
    }
  }

  _validateUnitCostAndSale(row) {
    // if (+row['unitCost'] > +row['unitSale']) {
    //   this._toastService.activateMsg('UI2020');
    // }
  }


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  getSmallUnitVal(units: Array<any>, itemCode): Array<any> {

    return units.filter(item => item.itemId == itemCode);
  }

  getItemFromItems(items: Array<any>, itemCode): Array<any> {

    return items.filter(item => item.code == itemCode);
  }



  _validateOnCount(row) {
    if (row.number == (undefined || null || 0)) {
      this._toastService.activateMsg('UI91');
      return 0;

    }
  }

  /*********************#######Azmio QR Code *************************/
  qrCodeParms: QrCodeParams = <QrCodeParams>{};
  qrResult: string;
  _generateQRCode(printTransInfo: any, printTotalTransinfo: any) {
    printTotalTransinfo.qrTotalPayedValue = printTotalTransinfo.qrTotalPayedValue ? printTotalTransinfo.qrTotalPayedValue : printTotalTransinfo.totalPayedValue;
    printTransInfo.receiptSerial = printTransInfo.receiptSerial ? printTransInfo.receiptSerial : printTransInfo.tranSerial
    printTransInfo.transDate = this.datePipe.transform(printTransInfo.regDate, 'yyyy-MM-dd hh:mm');
    /* new  code  After base64*/
    this.qrCodeParms.qrTotalPayedValue = ("" + printTotalTransinfo.qrTotalPayedValue + "");
    this.qrCodeParms.receiptSerial = ("" + printTransInfo.receiptSerial + "");
    this.qrCodeParms.branchNameArQ = ("" + printTransInfo.branchNameArQ + "");
    this.qrCodeParms.vatRegNo = ("" + printTransInfo.vatRegNo + "");
    this.qrCodeParms.transDate = ("" + printTransInfo.transDate + "");
    this.qrCodeParms.totalPatVat = ("" + printTotalTransinfo.totalPatVat + "");
    if (printTransInfo.receiptSerial && printTotalTransinfo) {
      this._generateQrCodeService.generateQrShape(this.qrCodeParms).pipe(
        takeUntil(this.ngUnsubscribe))
        .subscribe(
          res => {
            if (res) {
              this.qrResult = res;
              return this.qrResult;
            }
            else {
              this._toastService.activateMsg('Error Check Api:' + '( GenerateQrCodeController )');
            }
          },
          error => console.log(error),
          () => {
          });
    }
    return this.qrResult;

    /*********************#######Azmio *********************/
    /* old code  before base64*/
    //   let QRCodeData = ('اسم المنشاه:' + printTransInfo.branchNameArQ
    //     + '\n' + 'الرقم الضريبي:' + printTransInfo.vatRegNo + '\n' +
    //     'رقم الفاتورة:' + printTransInfo.receiptSerial + '\n'
    //     + 'تاريخ الفاتورة:' + printTransInfo.transDate.toLocaleString() +
    //     '\n' + ' اجمالى الفاتورة (مع الضريبة):'
    //     + printTotalTransinfo.qrTotalPayedValue + ' ' + 'ر.س'
    //     + '\n' + 'ضريبة القيمة المضافة:'
    //     + printTotalTransinfo.totalPatVat + ' ' + 'ر.س'
    //   )
    //   return QRCodeData;
    // 
  }
}

